import { createContext, useContext } from "react";

export interface ListItemDataContextProps {
  item: any;
  listeners: any;
}

const ListItemData = createContext<ListItemDataContextProps>({
  item: {},
  listeners: {},
});
ListItemData.displayName = "ListItemData";

export const useListItemDataProvider = () => useContext(ListItemData);

export interface ListItemDataProviderProps {
  children: React.ReactNode;
  item: any;
  listeners: any;
}

export const ListItemDataProvider = ({
  item,
  listeners,
  children,
}: ListItemDataProviderProps) => (
  <ListItemData.Provider
    value={{
      item,
      listeners,
    }}
  >
    {children}
  </ListItemData.Provider>
);
